// generated by srcset-codegen
import src from "./tag.svg";

const width = 14;
const height = 14;
export default { src, width, height };
